import React from 'react';

import classes from './SideDrawer.module.css';

import Logo from '../../Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';
import Auxilliary from '../../../hoc/Auxilliary/Auxilliary';
import Backdrop from '../../UI/Backdrop/Backdrop';

const SideDrawer = (props) => {
	const attachedClasses = [classes.SideDrawer, classes.Close];

	if (props.open) {
		attachedClasses[1] = classes.Open;
	}

	return (
		<Auxilliary>
			<Backdrop clicked={props.close} show={props.open} />
			<div className={attachedClasses.join(' ')}>
				<div className={classes.Logo}>
					<Logo />
				</div>
				<nav>
					<NavigationItems
						itemsClicked={props.close}
						isAuthenticated={props.isAuthenticated}
					/>
				</nav>
			</div>
		</Auxilliary>
	);
};
export default SideDrawer;
